import { ApiResponse } from "../../types";
import { apiClient } from "../client";

export interface Fund {
  key: string;
  value: string;
}

export interface FileStatusParams {
  datetime: string;
  docType: string;
  dbName: string;
}

export interface FileStatusItem {
  id: string;
  created_by: string;
  size: number;
  real_name: string;
  doc_type: string;
  status: string;
  error: string;
}

// O apiClient já desempacota o { data: [...] } que a lambda devolve, então o
// tipo aqui é a lista em si. Declarar um envelope extra fazia o
// response.data.data dos hooks passar no compilador e virar undefined em
// runtime — era por isso que a tabela de status vinha sempre vazia.

export const liquidationService = {
  async getAvailableFunds(): Promise<ApiResponse<Fund[]>> {
    return apiClient.get("/availableFunds");
  },

  async getFileStatus(
    params: FileStatusParams
  ): Promise<ApiResponse<FileStatusItem[]>> {
    return apiClient.post("/filestatus", params);
  },
};
